import axios from 'axios';

/**
 * Cancel confirmed shipment request (OM-69).
 */
export interface CancelShipmentRequest {
  trackingPin?: string;
  /** Browser local calendar date YYYY-MM-DD. */
  localDate: string;
  cancelToken?: string;
}

/**
 * Successful cancel response from POST /shipments/cancel.
 */
export interface CancelShipmentSuccessResponse {
  status: 'CANCELLED';
  trackingPin: string;
  shipmentCreationDate: string;
  cancelledAt: string;
  pickupCancelled: boolean;
  alreadyCancelled: boolean;
}

/** i18n key for generic cancel API failures. */
export const CANCEL_ERROR_I18N_KEY = 'createShipment.getLabels.cancelError';

/** i18n key when BE rejects cancel outside the same-day window (OM-69 AC5). */
export const CANCEL_OUTSIDE_WINDOW_I18N_KEY = 'createShipment.getLabels.cancelOutsideWindow';

/**
 * Returns true when the cancel API rejected the request as outside the window / not eligible.
 */
export function isCancelOutsideWindowError(error: unknown): boolean {
  if (!axios.isAxiosError(error) || error.response?.status !== 409) {
    return false;
  }

  const payload = error.response.data as { errors?: { code?: string }[] } | undefined;
  const errors = payload?.errors;
  if (!Array.isArray(errors) || errors.length === 0) {
    return true;
  }

  return errors.some(
    (item) => item?.code === 'CANCEL_OUTSIDE_WINDOW' || item?.code === 'CANCEL_NOT_ELIGIBLE',
  );
}

/**
 * Resolves the Get Labels / deep-link cancel error toast i18n key.
 */
export function resolveCancelErrorI18nKey(error: unknown): string {
  return isCancelOutsideWindowError(error) ? CANCEL_OUTSIDE_WINDOW_I18N_KEY : CANCEL_ERROR_I18N_KEY;
}
